// Date-only values (YYYY-MM-DD) must never shift by timezone: parse as a local calendar date.
export const formatDateOnly = (value, opts) => {
  if (!value) return "—";
  const s = String(value);
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  const d = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(s);
  return Number.isNaN(d.getTime()) ? s : d.toLocaleDateString(undefined, opts);
};
